import { render } from "./DocTypesList.vue?vue&type=template&id=6cf80be4&scoped=true"
import script from "./DocTypesList.vue?vue&type=script&lang=js"
export * from "./DocTypesList.vue?vue&type=script&lang=js"

import "./DocTypesList.vue?vue&type=style&index=0&id=6cf80be4&scoped=true&lang=css"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cf80be4"]])

export default __exports__